import { Outlet, useLocation } from "react-router-dom"
import { SideBar } from "./SideBar"
import { useEffect, useState } from "react";
import DeletePopup from "../../components/DeletePopup";


export const AdminLayout = () => {
    const [fullScreen, setFullScreen] = useState<boolean>(true);
    const location = useLocation();

    const isPdfPage = location.pathname.includes("/admin/PurchaseOrder");

    useEffect(() => {
        const navbar = document.querySelector("nav");

        if (!(navbar instanceof HTMLElement)) return;

        if (location.pathname.startsWith("/admin/PurchaseOrder")) {
            navbar.style.display = "none";
        } else {
            navbar.style.display = "";
        }

        return () => {
            navbar.style.display = "";
        };
    }, [location.pathname]);

    const handleScreen = () => {
        setFullScreen(!fullScreen);
    }

    if (isPdfPage) {
        return <Outlet />;
    }

    return (
        <div className="flex bg-blue-50">
            <SideBar handleScreen={handleScreen} />
            <div className={`${fullScreen ? 'w-[calc(100%-224px)]' : 'w-[calc(100%-50px)]'} h-max`}>
                <Outlet />
                <DeletePopup />
            </div>
        </div>
    )
}